var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "filter-criteria",
    { attrs: { variant: "primary" } },
    [
      _c("font-awesome", {
        staticClass: "font-awesome",
        attrs: { icon: ["far", "calendar-alt"] },
      }),
      _vm._v(
        "\n  " + _vm._s(_vm.startDate) + " - " + _vm._s(_vm.endDate) + "\n"
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }